const routes = ['all', 'any'];

const includesAllRoute = (route) => routes.includes(route);

export default includesAllRoute;
